import Component from '@glimmer/component';
import { useStyles } from '@frontile/theme';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

class FormFieldFeedback extends Component {
  get isError() {
    return typeof this.args.errors !== 'undefined' || this.args.isError === true;
  }
  get classes() {
    const {
      formFeedback
    } = useStyles();
    return formFeedback({
      size: this.args.size,
      intent: this.isError ? 'danger' : 'primary',
      class: this.args.class
    });
  }
  get errorMessage() {
    if (!this.args.errors) return '';
    if (typeof this.args.errors === 'string') {
      return this.args.errors;
    } else {
      return this.args.errors.join('; ');
    }
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div id={{@id}} class={{this.classes}} data-test-id=\"form-field-feedback\" aria-live={{if this.isError \"assertive\" \"polite\"}} ...attributes>\n      {{this.errorMessage}}\n      {{yield}}\n    </div>\n  ", {
      strictMode: true
    }), this);
  }
}

export { FormFieldFeedback as default };
//# sourceMappingURL=feedback.js.map
